import {
  Activity, Bell, Bot, CircuitBoard, ClipboardList, Cpu, Database, Droplets, Edit3, FileBarChart, FileText, Globe,
  HelpCircle, MonitorPlay, Users, Wrench, Zap,
} from 'lucide-react';

// The client portal sidebar screens, in sidebar order. Each client can rename any of them
// (Admin → Screen Names); the names live in the client's theme config as `screenLabels`.
// `module` is the client module that switches the screen on; `defaultOn` mirrors the
// server defaults (core modules are on unless switched off, newer ones are opt-in).

export type ClientScreenMeta = { id: string; label: string; icon: any; module: string; defaultOn: boolean };

export const CLIENT_SCREENS: ClientScreenMeta[] = [
  { id: 'machine', label: 'Energy Meters', icon: Zap, module: 'energyConsumption', defaultOn: true },
  { id: 'energy-forecast', label: 'Energy Forecast', icon: Zap, module: 'energyForecast', defaultOn: false },
  { id: 'chat-bot', label: 'Chat Bot', icon: Bot, module: 'chatBot', defaultOn: false },
  { id: 'scanners', label: 'Scanners', icon: Cpu, module: 'scanners', defaultOn: true },
  { id: 'waveshare-8ch', label: 'Waveshare 8CH', icon: CircuitBoard, module: 'waveshare8ch', defaultOn: false },
  { id: 'logging', label: 'Manual Logging', icon: Edit3, module: 'manualLogging', defaultOn: true },
  { id: 'plc', label: 'Live PLC Data', icon: Activity, module: 'livePlcData', defaultOn: true },
  { id: 'offline', label: 'Offline Data', icon: Database, module: 'offlineData', defaultOn: true },
  { id: 'scrap', label: 'Scrap Management', icon: Activity, module: 'scrapManagement', defaultOn: true },
  { id: 'raise-ticket', label: 'Raise Ticket', icon: HelpCircle, module: 'supportTickets', defaultOn: true },
  { id: 'my-tickets', label: 'My Tickets', icon: HelpCircle, module: 'supportTickets', defaultOn: true },
  { id: 'historical', label: 'Reports', icon: FileText, module: 'reports', defaultOn: true },
  { id: 'hmi', label: 'HMI', icon: MonitorPlay, module: 'hmi', defaultOn: true },
  { id: 'external-monitor', label: 'Monitor', icon: Globe, module: 'externalMonitor', defaultOn: false },
  { id: 'plant-kpi', label: 'Plant KPIs', icon: Droplets, module: 'plantKpi', defaultOn: false },
  { id: 'maintenance-scheduler', label: 'Maintenance Scheduler', icon: Wrench, module: 'maintenanceScheduler', defaultOn: false },
  { id: 'team-activity', label: 'Team Activity', icon: Users, module: 'teamActivity', defaultOn: false },
  { id: 'automated-reports', label: 'Automated Reports', icon: Bell, module: 'automatedReports', defaultOn: false },
  { id: 'report-builder', label: 'Report Builder', icon: FileBarChart, module: 'automatedReports', defaultOn: false },
  { id: 'batch-reports', label: 'Batch Reports', icon: ClipboardList, module: 'batchReports', defaultOn: false },
  { id: 'copilot', label: 'Operations Copilot', icon: Bot, module: 'copilot', defaultOn: false },
];

export const SCREEN_LABEL_MAX = 40;

/** The client's own name for a screen, or null when they use the default. */
export function customScreenLabel(themeConfig: any, screenId: string): string | null {
  const v = themeConfig?.screenLabels?.[screenId];
  return typeof v === 'string' && v.trim() ? v.trim().slice(0, SCREEN_LABEL_MAX) : null;
}

/** Whether the client's modules switch this screen on (permissions can still hide it per user). */
export function screenModuleOn(modules: any, screen: ClientScreenMeta): boolean {
  const v = modules?.[screen.module];
  return screen.defaultOn ? v !== false : v === true;
}
